<label *ngFor="let option of options" [class.active]="option.id === componentFormControl.value">
    <input type="radio" [formControl]="componentFormControl" [value]="option.id" />

    <img [src]="getImageSrc(option.label)" alt="" />

    <div class="checkbox">
        <mg-ui-animated-check-dot [isChecked]="option.id === componentFormControl.value"> </mg-ui-animated-check-dot>
        <h4>{{ option.label }}</h4>
    </div>
</label>
